var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',[(!_vm.codeLoading)?_c('img',{staticClass:"codeimg",attrs:{"src":_vm.imgSrc},on:{"click":_vm.getCode}}):_c('div',{staticClass:"codeimg",staticStyle:{"line-height":"inherit"}},[_c('Spin',{attrs:{"fix":""}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }